module.exports = __webpack_public_path__ + "static/logo-1589c54dee1269ee42a4f0584cbe79fd.png";